/**
 * The Designer's and the Operator's page while the server has no valid license.
 *
 * `noLicense`, not `license`: the i18n check reads any quoted `license.…` as a key, and
 * `license.key` is an expression the control center's templates use.
 */
export default {
	noLicense: {
		title: "No valid license",
		note: "This server has no valid license, so the Designer and the Operator are closed. Ask a server administrator to enter a license key.",
		noteAdmin:
			"This server has no valid license, so the Designer and the Operator are closed. Enter a license key in the control center; it stays open.",
		openControlCenter: "Open the license settings",
		tryAgain: "Try again",
	},
};
